import type { AccountUsecase, MessageUsecase } from '@/apis/usecases'
import {
  AccountInteractor,
  MessageInteractor,
} from '@/apis/usecases/interactors'
import { TYPES } from '@/libs/di/types'
import { ContainerModule } from 'inversify'

export const usecases = new ContainerModule(bindOptions => {
  bindOptions.bind<AccountUsecase>(TYPES.AccountUsecase).to(AccountInteractor)
  bindOptions.bind<MessageUsecase>(TYPES.MessageUsecase).to(MessageInteractor)
})
